import { store } from '../store';
import {createApp} from 'vue';
import {sendPetition} from './scripts';
import countriesCA from '../../assets/data/paisos_ca.json';

import comarques from '../../assets/data/municipalities.json'
import axios from 'axios';

if(document.querySelector('.p-collegiat-directory')){
	var app_courses_module = createApp({
		data(){
			return {
				collegiatsHTML: '',
				loading: false,
				towns: [],
				firstNameInput: '',
				lastNameInput: '',
				cityInput: '',
				postalCodeInput: '',

				currentFocus: 0,
			}
		},
		computed: {
		},
		watch: {
		},
		mounted(){
			console.log('initializing collegiat directory page');
			//console.log(wp_js_var.ajax_url);

			let vm = this;

			vm.fillTowns();

			document.addEventListener("click", function (e) {
				vm.closeAllLists(e.target);
			});
		},
		methods:{
			fillTowns: function(){
				this.towns = [];
				let aux_towns = []
				comarques.forEach(comarca => {
					aux_towns.push(...comarca.cities);
				})
				this.towns = aux_towns.map( a => a.name)
			},
			formSubmit: function (event){
				event.preventDefault();
				/* If no town is selected and the input is empty -> town = '' */
				/* If no town is selected and the input is not empty -> town = 1st in suggestions */
				
				if (!this.cityFieldValid()) {
					this.loading = true;
					this.$refs.pageCollegiats.innerHTML = "";
					axios.post(
						wp_js_var.ajax_url,
						{
							action: 'get_collegiats',
							firstname: this.firstNameInput,
							lastname: this.lastNameInput,
							city: this.cityInput,
							postalcode: this.postalCodeInput,
						}, 
						{
							headers: {
								'Content-Type': 'multipart/form-data'
							}
						}
					)
						.then(petition => {
							this.loading = false;
							this.$refs.pageCollegiats.innerHTML = petition.data.html;
						})
				}
			},
			inputEvent: function(event){
				let vm = this;
				var a, b, i, val = vm.cityInput;
				vm.closeAllLists();
				if (!val) { return false;}
				vm.currentFocus = -1;
				a = document.createElement("DIV");
				a.setAttribute("id", vm.id + "autocomplete-list");
				a.setAttribute("class", "autocomplete-items");
				event.target.parentNode.appendChild(a);
				for (i = 0; i < vm.towns.length; i++) {
					if (vm.towns[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
						b = document.createElement("DIV");
						b.innerHTML = "<strong>" + vm.towns[i].substr(0, val.length) + "</strong>";
						b.innerHTML += vm.towns[i].substr(val.length);
						b.innerHTML += `<input type="hidden" value="${vm.towns[i]}">`;
						b.addEventListener("click", function(e) {
							vm.cityInput = this.getElementsByTagName("input")[0].value;
							vm.closeAllLists();
						});
						a.appendChild(b);
					}
				}
			},
			keydownEvent: function(event){
				var x = document.getElementById(this.id + "autocomplete-list");
				if (x) x = x.getElementsByTagName("div");
				if (event.keyCode == 40) {
					this.currentFocus++;
					this.addActive(x);
				} else if (event.keyCode == 38) {
					this.currentFocus--;
					this.addActive(x);
				} else if (event.keyCode == 13) {
					event.preventDefault();
					if (this.currentFocus > -1) {
						if (x) x[this.currentFocus].click();
					}
				}
			},
			addActive: function (x) {
				if (!x) return false;
				this.removeActive(x);
				if (this.currentFocus >= x.length) this.currentFocus = 0;
				if (this.currentFocus < 0) this.currentFocus = (x.length - 1);
				if(x) x[this.currentFocus].classList.add("autocomplete-active");
			},
			removeActive: function (x) {
				for (var i = 0; i < x.length; i++) {
					x[i].classList.remove("autocomplete-active");
				}
			},
			closeAllLists: function (elmnt) {
				var x = document.getElementsByClassName("autocomplete-items");
				for (var i = 0; i < x.length; i++) {
					if (elmnt != x[i] && elmnt != this.$refs.cityInputEl) {
						x[i].parentNode.removeChild(x[i]);
					}
				}
			},
			cityFieldValid: function() {
				if (this.cityInput != '' && this.towns.filter(town=> town.toLowerCase() === this.cityInput.toLowerCase()).length < 1) {
					return true;
				}
				return false;
			}
		}
	}).mount(document.querySelector('.p-collegiat-directory'));
}